// 这里放置一些Vue自定义Filter
export const formatTime = (time, accurateDay) => {
  if (time == null || time == '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  if (!accurateDay) {
    let hours = tmpDate.getHours()
    if (hours < 10) {
      hours = '0' + hours
    }
    let minutes = tmpDate.getMinutes()
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    return year + '-' + mathon + '-' + day + ' ' + hours + ':' + minutes
  } else {
    return year + '-' + mathon + '-' + day
  }
}

export const timeToDateByDay = (time, accurateDay) => {
  if (time == null || time == '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + mathon + '-' + day
}

export const timeToDateBySeconds = (time) => {
  if (time == null || time == '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let hours = tmpDate.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }
  let minutes = tmpDate.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  let seconds = tmpDate.getSeconds()
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return year + '-' + mathon + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export const timeSubstring = (str) => {
  if (str == null) return null
  let tempStr = str.substr(0, 10)
  return tempStr
}

/** 格式化时间 **/
export const FormatDate = function (dateStr, fmt) {
  if (dateStr === '' || dateStr === null) {
    return false
  }
  dateStr = dateStr instanceof Date ? dateStr : new Date(dateStr)
  var o = {
    'M+': dateStr.getMonth() + 1,
    'd+': dateStr.getDate(),
    'h+': dateStr.getHours(),
    'm+': dateStr.getMinutes(),
    's+': dateStr.getSeconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (dateStr.getFullYear() + '').substring(4 - RegExp.$1.length))
  }
  for (var key in o) {
    if (new RegExp('(' + key + ')').test(fmt)) {
      let concatKey = '00' + o[key]
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? o[key] : concatKey.substring(concatKey.length - 2))
    }
  }
  return fmt
}
